import { ReactNode, CSSProperties, HTMLAttributes  } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { ComponentProps } from "react";
import { useTheme } from "@mui/material/styles";

type CustomScrollProps = ComponentProps<typeof Scrollbars>;

const CustomScroll = ({ children, ...rest }: CustomScrollProps) => {

    const theme = useTheme();

    return (
        <Scrollbars
            {...rest}
            //style={style}
            renderThumbVertical={(
                { style, ...props }: {
                    style: CSSProperties;
                } & HTMLAttributes<HTMLDivElement>
                ) => (
                <div
                    {...props}
                    style={{
                    ...style,
                    backgroundColor: theme.palette.primary.main,
                    width: 4,
                    borderRadius: 8,
                    }}
                />
            )}
        >
        {children}
        </Scrollbars>
    );
}

export default CustomScroll;
  